import { Component, Injectable,HostListener, OnInit, VERSION,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
  AfterViewInit, } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from './services/auth.service';
import { CustomService } from './services/custom.service';
import { TimezoneService } from './services/timezone.service';
import { UserService } from './services/user.service';
import swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import * as Global from 'src/app/global';
import { Location } from '@angular/common';
import { IdleService } from './services/idle.service';
import { Subscription } from 'rxjs';
//import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { Socket } from 'ngx-socket-io';
//import {SpeedTestService} from 'ng-speed-test';

import { Observable, Observer, fromEvent, merge, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { share } from 'rxjs/operators';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { UserIdleService } from 'angular-user-idle';
import { takeUntil } from 'rxjs/operators';
import * as AOS from 'aos';

@Injectable()

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    PageMainTitle = environment.APP_NAME;
    private idleTimer: any;
   //status: OnlineStatusType; //Enum provided by ngx-online-status
   // onlineStatusCheck: any = OnlineStatusType;
    onlineMessage : any
    serverTime: any
    connection: any;
    downlinkSpeed: string | null = null;
    speedTestResult: { uploadSpeed: number; downloadSpeed: number };
    speedData: { download: number, upload: number };
    currentPath: string;
    currentUrl: string;
    intervalId: any;
    updatedTimestamp : any = 0
    serverTime1: any;
    timestampval : any;
    timestamp : any;
    date :any;
    private tabSubscription: Subscription;
    isActiveTab = true;
    private readonly destroyed$: Subject<void> = new Subject();

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
        private authService: AuthService,
        private customService: CustomService,
        private timezoneService: TimezoneService,
        private toastr: ToastrService,
        private spinner: NgxSpinnerService,
        private userService: UserService,
        private socket: Socket,
        private location: Location,

        private userIdle: UserIdleService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly idleService: IdleService,

    ) {


      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationStart) {
          if (this.authService.userLoggedIn()) {
            //this.checkServerSyncTime()
          }
           //console.log('NavigationStart');

        }
        if (event instanceof NavigationEnd) {
        }
      });

      this.currentPath = this.location.path();


     }



    ngOnDestroy() {
      this.destroyed$.next();
      this.destroyed$.complete();
      clearInterval(this.intervalId);
    }
    checkServerSyncTime() {
      clearInterval(this.intervalId);



      this.userService.checkServerValidTimezone({
      }).subscribe((res) => {
          const data = res?.data ?? null;
          const serverTime1 = data?.useservertime
          const timestampval = serverTime1;
          const timestamp = Number(timestampval);
          const date = new Date(timestamp);
          this.intervalId = setInterval(() => {
            date.setSeconds(date.getSeconds() + 1);
            this.serverTime = date.getTime()
            this.customService.timer.next(this.serverTime)
            console.log('Datetime : '+new Date(this.serverTime));
          }, 1000);
      }, (err) => {

          this.toastr.error(Global.getServerErrorMessage(err));
      })
    }

    ngOnInit() {
      AOS.init({disable: 'mobile'});//AOS - 2
      AOS.refresh();//refresh method is called on window resize and so on, as it doesn't require
      document.addEventListener('visibilitychange', () => {

    if (!document.hidden) {
      this.socket.connect();
    }
  });

       this.getInternetStatus();





      this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                //this.checkServerSyncTime();

                const rt = this.getActivatedRouteChild(this.activatedRoute);
                document.getElementById('navbarSupportedContent')?.classList.remove('show');
                rt.data.subscribe((data: any) => {
                    if (data.pageTitle) {
                        this.titleService.setTitle(data.pageTitle + ' - ' + this.PageMainTitle)
                    } else {
                        this.titleService.setTitle(this.PageMainTitle)
                    }
                });

                if (this.authService.userLoggedIn()) {
                    this.refreshUserAccountDetails();

                }
            }
        });
    }


    createOnline$() {
      return merge(
        fromEvent(window, 'offline').pipe(map(() => false)),
        fromEvent(window, 'online').pipe(map(() => true)),
        new Observable((sub: Observer<boolean>) => {
          sub.next(navigator.onLine);
          sub.complete();
        })
      );
    }



    async getInternetStatus(){
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
           //console.log('NavigationEnd');

           this.createOnline$().subscribe((isOnline) => {
            //console.log(isOnline);

            if (isOnline) {
              //swal.close()
              if (!this.socket.ioSocket.connected) {
                this.socket.connect();
              }

            } else {
              this.onlineMessage =
                'Connection lost, Please check your internet connection.';
                this.socket.disconnect();
                //console.log('onlineMessage : ',this.onlineMessage);
                  swal.fire({
                      //title: `Your clock is ${data.diff < 0 ? 'behind' : 'ahead'}`,
                      title : `Connection lost`,
                      text: `
                      Please check your internet connection and retry
                      `,
                      // text: `A connection can't be established because your computer's date and time ${ new Date().toLocaleString() } are incorrect`,
                      //iconHtml: '<img  src="assets/img/wifi.png">',
                      icon: 'warning',
                      showCancelButton: false,
                      showConfirmButton: true,
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      confirmButtonText: 'Refresh',
                      cancelButtonText: "",
                      customClass: { container: 'clockerror-swal' }
                  }).then(async (result) => {
                  if (result.isConfirmed) {
                    //console.log('ok');
                    window.open(this.currentPath,'_self');
                    location.reload();
                    //await this.getInternetStatus()
                }
              });
            }
          });
        }
      });
    }
    getActivatedRouteChild(activatedRoute: ActivatedRoute): ActivatedRoute {
        if (activatedRoute.firstChild) {
            return this.getActivatedRouteChild(activatedRoute.firstChild);
        } else {
            return activatedRoute;
        }
    }

    refreshUserAccountDetails() {
        this.authService.getUserAccount().subscribe((res) => {
            const data = res.data ?? null;
            if (res.status == 'success') {
                this.authService.setUserSessionDetails({
                    user: data?.user ?? null
                })
            }
        }, (err) => {
            this.customService.handleServerExceptions(err);
        })
    }
  //  async checkServerSyncTime({ loading = <boolean>false } = {}) {
  //     if (loading == true) this.spinner.show();
  //     this.userService.checkServerValidTimezone({
  //         'localtime': new Date(),
  //     }).subscribe((res) => {
  //         if (loading == true) this.spinner.hide();
  //         const data = res?.data ?? null;
  //         console.log('localTime : ',new Date());
  //         console.log('API Response : ',data);
  //         localStorage.setItem('serverTime', data?.useservertime)
  //         if (data?.diff != 0) {
  //             swal.fire({
  //                 //title: `Your clock is ${data.diff < 0 ? 'behind' : 'ahead'}`,
  //                 title : `Your date and time settings are not in sync`,
  //                 text: `
  //                 Please go to date and time settings to switch on “Set time automatically” and click on “sync now” from additional settings

  //                 If date and time settings are not updated, it might lead to inaccurate real time data updation
  //                 `,
  //                 // text: `A connection can't be established because your computer's date and time ${ new Date().toLocaleString() } are incorrect`,
  //                 iconHtml: '<img src="assets/img/clock-error.png">',
  //                 icon: 'warning',
  //                 showCancelButton: true,
  //                 allowOutsideClick: false,
  //                 allowEscapeKey: false,
  //                 confirmButtonText: 'Refresh',
  //                 cancelButtonText: "Setting",
  //                 customClass: { container: 'clockerror-swal' }
  //             }).then(async (result) => {
  //               if (result.isConfirmed) {

  //                 // let current_url = 'dashboard/buyer/reports/generate';
  //                 // this.router.navigateByUrl(current_url)
  //                 await this.checkServerSyncTime()

  //             } else if (result.isDismissed && result.dismiss === swal.DismissReason.cancel) {
  //                 // function when cancel button is clicked
  //                 let current_url = data?.video;
  //                  window.open(current_url, '_blank');
  //             }
  //            });
  //         }
  //     }, (err) => {
  //         if (loading == true) this.spinner.hide();
  //         this.toastr.error(Global.getServerErrorMessage(err));
  //     })
  // }



}
